function initCustomSelect() {
  const customSelectMain = document.querySelector('.custom-select__selected');
  const customSelect = document.querySelector(".custom-select");
  const selectID = document.querySelector('.main-custom-select')?.previousElementSibling?.getAttribute('for');
  const variantSelect = document.getElementById(selectID);

  if (customSelectMain && customSelect && variantSelect) {
    // Prevent double init using data attribute
    if (customSelect.dataset.initialized === 'true') return;

    customSelect.dataset.initialized = 'true'; // Mark as initialized

    // Toggle dropdown
    customSelectMain.addEventListener("click", () => {
      customSelect.classList.toggle('active');
    });

    // Setup custom options
    const customOptions = document.querySelectorAll('.custom-select__options');

    customOptions.forEach(option => {
      // Optional: prevent duplicate listeners
      if (option.dataset.initialized === 'true') return;
      option.dataset.initialized = 'true';

      option.addEventListener('click', function () {
        const variantId = this.getAttribute('data-value');
        if (!variantId) return;

        const matchingOption = [...variantSelect.options].find(opt => opt.value === variantId);
        if (matchingOption) {
          variantSelect.value = variantId;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          customSelectMain.textContent = this.textContent;
          customSelect.classList.remove('active');
        }
      });
    });
  }
}

// 🔁 Hook into lifecycle events safely
document.addEventListener("DOMContentLoaded", initCustomSelect);

subscribe(PUB_SUB_EVENTS.variantChange, function({ data }) {
  if (data.variant) {
    initCustomSelect();
  }
});

document.addEventListener('variantChange', () => {
  setTimeout(() => {
    initCustomSelect();
  }, 100); // Give the DOM time to update
});
